<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center login_content_area">
        <div class="col-lg-7 col-md-12">
          <shadow-container>
            <div class="row justify-content-center">
              <div class="col-lg-7 col-md-12">
                <div class="row">
                  <div class="col-12">
                    <form
                      class="lar_form"
                      @submit.prevent="letMeLogin"
                    >
                      <form-row>
                        <p class="text-center col-12">
                          請輸入{{ accountName() }}及密碼登入
                        </p>
                      </form-row>
                      <form-row>
                        <form-group
                          cols="12"
                        >
                          <input-group
                            :has-error="!$v.registrationId.required"
                            error-message="帳號必填"
                          >
                            <template slot="prepend">
                              <span
                                aria-hidden="true"
                                class="input-group-text text-muted"
                              >
                                <font-awesome-icon :icon="idIcon" />
                              </span>
                            </template>
                            <form-input
                              v-model.trim="$v.registrationId.$model"
                              :has-error="$v.registrationId.$error"
                              :placeholder="idPlaceholder"
                              :name="idName"
                            />
                          </input-group>
                        </form-group>
                      </form-row>
                      <form-row>
                        <form-group
                          cols="12"
                        >
                          <input-group
                            :has-error="!$v.registrationPassword.required || !$v.registrationPassword.minLength"
                            :error-message="!$v.registrationPassword.minLength ? '密碼至少6個字元' : '密碼必填'"
                          >
                            <template slot="prepend">
                              <span
                                aria-hidden="true"
                                class="input-group-text text-muted"
                              >
                                <font-awesome-icon icon="lock" />
                              </span>
                            </template>
                            <form-input
                              v-model.trim="$v.registrationPassword.$model"
                              :has-error="$v.registrationPassword.$error"
                              type="password"
                              placeholder="登入密碼"
                              :name="passwordName"
                            />
                          </input-group>
                        </form-group>
                      </form-row>
                      <form-row>
                        <div
                          id="g-recaptcha"
                        />
                      </form-row>
                      <form-row>
                        <form-group
                          cols="6"
                        >
                          <template slot="form-check">
                            <div class="form-check">
                              <check-input
                                v-model="rememberLogin"
                                name="remember-login-info"
                                label="記住我的登入資訊"
                              />
                            </div>
                          </template>
                        </form-group>
                        <div class="col-6 text-right">
                          <span
                            class="text-primary"
                            @click="openForgetPasswordModal"
                          >忘記密碼？</span>
                        </div>
                      </form-row>
                      <form-row>
                        <button
                          class="btn--pill btn--fill pill--lg pill darken_blue"
                        >
                          登入
                        </button>
                      </form-row>
                    </form>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 divider" />
                </div>

                <div class="row">
                  <div class="col-12">
                    <p class="text-center">
                      尚未有帳號？請點以下按鈕開始註冊：
                    </p>
                  </div>
                  <div class="col-12">
                    <button
                      class="btn--pill btn--fill pill--lg pill lighten_gray"
                      @click="openRegistrationModal"
                    >
                      <div class="row">
                        <div class="col-6 text-left">
                          註冊
                        </div>
                        <div class="col-6 text-right">
                          <font-awesome-icon icon="arrow-right" />
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </shadow-container>
        </div>
      </div>
    </div>
    <bootstrap-modal
      :modal-title="modalTitle"
      :is-open="openModal"
      @modal:close="closeRegistrationModal"
      @modal:okay="sendEmail"
    >
      <div class="col">
        <form>
          <form-row>
            <form-group cols="12">
              <slot />
            </form-group>
          </form-row>
        </form>
      </div>
    </bootstrap-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, minLength } from 'vuelidate/lib/validators'
import ShadowContainer from '~components/common/ShadowContainer'
import FormRow from '~components/common/form/Row'
import FormGroup from '~components/common/form/Group'
import FormInput from '~components/common/form/input'
import CheckInput from '~components/common/form/input/Check'
import InputGroup from '~components/common/form/input/Group'
import BootstrapModal from '~bootstrap/Modal'
export default {
  name: 'LoginContent',
  components: {
    ShadowContainer,
    FormRow,
    FormGroup,
    FormInput,
    CheckInput,
    InputGroup,
    BootstrapModal
  },
  mixins: [validationMixin],
  props: {
    idType: {
      type: String,
      required: true,
      validator: value => 'enterprise' || 'student' || 'teacher'
    },
    idPlaceholder: {
      type: String,
      default: ''
    },
    idName: {
      type: String,
      default: ''
    },
    idIcon: {
      type: String,
      default: 'user'
    },
    passwordName: {
      type: String,
      default: ''
    },
    registerTitle: {
      type: String,
      default: '請輸入您的信箱'
    },
    forgetPasswordTitle: {
      type: String,
      default: '忘記密碼？'
    }
  },
  data () {
    return {
      openModal: false,
      registrationId: '',
      registrationPassword: '',
      modalTitle: this.registerTitle,
      rememberLogin: true,
      canSubmit: false,
      notARobot: '',
      timer: null
    }
  },
  validations: {
    registrationId: {
      required
    },
    registrationPassword: {
      required,
      minLength: minLength(6)
    },
    notARobot: {
      required
    }
  },
  mounted () {
    this.setRecaptchaTimer()
  },
  methods: {
    ...mapActions('layouts', [
      'toggleModal'
    ]),
    accountName () {
      switch(this.idType) {
        case 'enterprise': return '統編';
        case 'student': return '學號';
        case 'teacher': return 'E-mail';
        default: return '帳號';
      }
    },
    setRecaptchaTimer () {
      this.timer = setInterval(() => {
        this.initializeRecaptcha()
      }, 1000)
    },
    clearRecaptchaTimer () {
      this.timer = clearInterval(this.timer)
    },
    initializeRecaptcha () {
      if (window.grecaptcha) {
        this.renderGoogleRecaptcha()
        this.clearRecaptchaTimer()
      }
    },
    renderGoogleRecaptcha () {
      const _this = this
      window.grecaptcha.render('g-recaptcha', {
        'sitekey': '6LcoZ-oeAAAAAHmFggIXN3Z95zDh2sAO74izVP8X',
        'callback': (token) => {
          if (token) {
            _this.notARobot = true
          }
        }
      })
    },
    openRegistrationModal () {
      this.$emit('clicked:sign-up')
      this.modalTitle = this.registerTitle
      this.openModal = true
      this.toggleModal(true)
    },
    closeRegistrationModal () {
      this.openModal = false
      this.toggleModal(false)
    },
    letMeLogin () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('login:submitted', {
          id: this.registrationId,
          password: this.registrationPassword
        })
        setTimeout(() => {
          this.closeRegistrationModal()
          returnRoute()
        }, 1000)
      }
    },
    letMeSignUp () {
      this.$emit('signup:submitted')
      setTimeout(() => {
        this.closeRegistrationModal()
      }, 1000)
    },
    sendEmail () {
      this.modalTitle === this.registerTitle ? this.letMeSignUp() : this.letMeResetPassword()
    },
    openForgetPasswordModal () {
      this.$emit('clicked:forget-password')
      this.modalTitle = this.forgetPasswordTitle
      this.openModal = true
      this.toggleModal(true)
    },
    letMeResetPassword () {
      this.$emit('password:forget')
      setTimeout(() => {
        this.closeRegistrationModal()
      }, 1000)
    }
  }
}


// 登入後要返回到之前的路由
const returnRoute = () => {
  let historyRoute = sessionStorage.getItem('route');
  if (historyRoute !== null){
    // 先清除紀錄在引導過去
    sessionStorage.removeItem('route')
    window.location.href = historyRoute;
  }
}
</script>
